import axios from 'axios'

export const getMaintenanceModeData = async () =>
  // eslint-disable-next-line no-return-await
  await axios.get('/api/config/features/check-maintenance', {
    baseURL: process.env.REACT_APP_BASE_URL,
  })
